// Template271: Pekín - Día 2 p.4 (Dia2Pagina2Pekin.jsx)
// Cabecera, mapa iframe + botón Ver mapa grande + tip + sticker, párrafo debajo.

import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import { useMapFullscreen } from "../../context/MapFullscreenContext";

const Template271 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const [fullscreen, setFullscreen] = useState(false);
	const { setMapFullscreen } = useMapFullscreen() || {};

	useEffect(() => {
		if (typeof setMapFullscreen === "function") {
			setMapFullscreen(fullscreen);
			return () => setMapFullscreen(false);
		}
	}, [fullscreen, setMapFullscreen]);

	const headerText = page?.texts?.[0]?.content;
	const tipMap = page?.texts?.[1]?.content;
	const paragraphBelow = page?.texts?.[2]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const stickerMap = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const mapUrl = page?.maps?.[0] || "";

	const actualHeaderColor = headerBackgroundColor || "#8c1d18";

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	if (fullscreen && mapUrl) {
		return (
			<div
				style={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					height: "100%",
					backgroundColor: "#fff",
					zIndex: 9999,
					display: "flex",
					flexDirection: "column",
				}}
			>
				<div
					style={{
						padding: "10px",
						textAlign: "right",
						backgroundColor: "#C41E3A",
						flexShrink: 0,
					}}
				>
					<button
						onClick={() => setFullscreen(false)}
						style={{
							backgroundColor: "#fff",
							color: "#24221a",
							border: "none",
							borderRadius: "8px",
							padding: "6px 12px",
							fontWeight: 600,
							cursor: "pointer",
							fontFamily: "'Poppins', sans-serif",
						}}
					>
						← Volver a la guía
					</button>
				</div>
				<iframe
					title="Mapa Torre del Tambor y hutongs"
					src={mapUrl}
					style={{
						border: 0,
						flex: 1,
						width: "100%",
						height: "100%",
						minHeight: 0,
					}}
					allowFullScreen
					loading="lazy"
				/>
			</div>
		);
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 66,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{/* Mapa */}
			<Box
				data-block-id="map"
				sx={{
					flex: 1,
					minHeight: isSmallScreen ? 320 : 400,
					marginTop: "-70px",
					position: "relative",
					display: "flex",
					flexDirection: "column",
				}}
			>
				{mapUrl ? (
					<iframe
						title="Mapa Torre del Tambor y hutongs"
						src={mapUrl}
						style={{
							border: 0,
							flex: 1,
							width: "100%",
							minHeight: 0,
						}}
						allowFullScreen
						loading="lazy"
					/>
				) : null}
				{mapUrl && (
					<button
						onClick={() => setFullscreen(true)}
						style={{
							position: "absolute",
							top: 80,
							right: 10,
							backgroundColor: "#C41E3A",
							color: "#fff",
							padding: "8px 10px",
							fontSize: "11px",
							borderRadius: "8px",
							fontFamily: "'Poppins', sans-serif",
							boxShadow: "1px 1px 2px rgba(0,0,0,0.2)",
							zIndex: 4,
							border: "none",
							cursor: "pointer",
						}}
					>
						Ver mapa grande
					</button>
				)}
				{tipMap && (
					<Box
						sx={{
							position: "absolute",
							bottom: isSmallScreen ? 60 : 75,
							left: 18,
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "16px 16px 16px 0px",
							padding: "10px 12px",
							fontSize: 11,
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: isSmallScreen ? 140 : 200,
							zIndex: 3,
						}}
					>
						{tipMap}
					</Box>
				)}
				{stickerMap && (
					<Box
						component="img"
						src={stickerMap}
						alt="sticker"
						sx={{
							width: 100,
							position: "absolute",
							bottom: 0,
							left: -10,
							zIndex: 2,
						}}
					/>
				)}
			</Box>

			{/* Texto debajo del mapa */}
			{paragraphBelow && (
				<Box data-block-id="text-1" sx={{ padding: "10px 12px", paddingBottom: 2 }}>
					<Box
						component="p"
						sx={{ ...estiloP, marginBottom: 1 }}
						dangerouslySetInnerHTML={{ __html: paragraphBelow }}
					/>
				</Box>
			)}
		</Box>
	);
};

Template271.thumbnail = "/images/template-1.png";
export default Template271;
